module.exports = __webpack_public_path__ + "img/if_4.b45f0d8b.png";